import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { ConfirmationService, MessageService, TreeNode } from 'primeng/api';
import { Table, TableRowCollapseEvent, TableRowExpandEvent } from 'primeng/table';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { TreeTable } from 'primeng/treetable';
import { LanguageService } from 'src/app/_services/language.service';

@Component({
  selector: 'app-ticket-edit',
  standalone: false,
  templateUrl: './ticket-edit.component.html',
  styleUrl: './ticket-edit.component.scss',
  providers: [MessageService],
  encapsulation: ViewEncapsulation.None 

})
export class TicketEditComponent implements OnInit {

  form = new FormGroup({});
  model: any = {};
  options: FormlyFormOptions = {};
  tabsFields:any[]=[];
  attachments:any[]=[];
  columnsOppourtunities:any[]=[];
  pageTitle:string="Nuovo ticket";
  backUrl:string='/tickets';
  action:any='';
  loading:boolean = true;
  isLoaded: Promise<boolean> | undefined;
  urlapi:string='';

  
  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    public lang :LanguageService,
    public router: Router,
  ) { }

  ngOnInit(): void {
    this.urlapi=this.globalService.endpoint+'tickets/tickets_attachments';

    let modulefields=this.globalService.configModules.filter((m)=>m.name=='tickets');
    this.tabsFields=modulefields[0].tabsFields;
    this.tabsFields.forEach((e:any)=>{
      if(e.fields){
        e.fields.forEach((f:any)=>{
          if(f.fieldGroup){
            f.fieldGroup.forEach((g:any)=>{
              if((g.props.options)&&(typeof g.props.options == 'string')) {
                g.props.options=this.apiService.postobs(g.props.options,{});
                g.props['valueProp']='value';
                g.props['labelProp']='label';
              }
            });
          }
        });
      }
    });
            
    this.action=this.route.snapshot.paramMap.get('action');
    if(this.route.snapshot.paramMap.get('id')){
      this.urlapi+='/'+this.route.snapshot.paramMap.get('id');
      this.pageTitle="Modifica ticket";
      this.apiService.post('tickets/tickets_listall',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.model = data2.Result[0];
      }); 
      this.apiService.post('tickets/tickets_listallattachments',{id:this.route.snapshot.paramMap.get('id')}).subscribe(data2 => {
        this.attachments = data2.Result;
      });    
      
    }

  }

  geturl(f:string){
    return this.globalService.endpointticketsattachments+'/'+f;
  }
  
  annulla(){
    this.router.navigateByUrl(this.backUrl);
  }

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

  
  onBeforeSend(event:any) {
       event.xhr.setRequestHeader("Authorization", `Bearer ${this.globalService.getToken()}`);
      
  }
  
  onUpload(event:any){
 
  }


  save(){
    if(this.action=='new'){
      this.model['created_by']=this.globalService.getUser().id;
    } 
    this.model['updated_by']=this.globalService.getUser().id;
    this.apiService.post('tickets/ticket_update',this.model).subscribe(data => {
      this.addSingle('success', this.lang.el('Successo'), this.lang.el('Record aggiornato'));
      setTimeout(() => {
         this.router.navigateByUrl(this.backUrl);   
      }, 1500);
    });
  }

  
}
